import React, { useMemo, useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CoordiApartmentTable from './CoordiApartmentTable'
import { useStudentListUnderCoordiList, useTranerUnderCoorList } from '../../assets/api/useCoordinatorApi';
import useAuthStore from '../../store/useAuthStore';
import AdminToolbar from '../admin/components/AdminToolbar';
import SelectBoxField from '../../shared/components/formfields/SelectBoxField';
import { Box } from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';

const CoordiApatmentList = () => {
  const { data: studentList, isLoading: isStudentListLoading } = useStudentListUnderCoordiList()
  const [selApartmentName, setSelApartmentName] = useState('')
  const matchedCount = studentList?.data?.filter(item => item.apartment_name === selApartmentName).length;
  const uniqueApartmentMap = new Map();
  studentList?.data?.forEach(item => {
    if (!uniqueApartmentMap.has(item.apartment_name)) {
      uniqueApartmentMap.set(item.apartment_name, item.apartment_id);
    }
  });

  const uniqueApartments = Array.from(uniqueApartmentMap.entries()).map(([name, id], index) => ({
    id: name,
    label: name,
    value: name,
    apartment_id: id,
    sr_no: index + 1,
  }));

  const originalRow = useMemo(() => {
    return studentList?.data?.map((item, index) => ({
      id: item?.id || index + 1,
      sr_no: index + 1,
      ...item
    })) || [];
  }, [studentList]);


  const filteredRows = useMemo(() => {
    if (!selApartmentName.trim()) {
      return originalRow;
    }

    return originalRow.filter(student => student.apartment_name === selApartmentName);
  }, [originalRow, selApartmentName]);



  const handleChangeApartment = (id) => {
    setSelApartmentName(id)

  };
  const handleClearApartment = () => {
    setSelApartmentName("")
  };

  return (

    <>
      <NormalContainerWithHeader headerText={"List of Students"} />
      <CustomDivider />
      <NormalContainerWithHeader headerText={selApartmentName ? `Student Count : ${matchedCount}` : ""}

        RightContent={
          <Box
            width={"40%"}
          >
            <SelectBoxField
              label="Apartment Name"
              options={uniqueApartments}
              isRequired={true}
              onChange={handleChangeApartment}
              ClearFunc={handleClearApartment}
              isloading={isStudentListLoading}
            />
          </Box>
        }
      >

        <CoordiApartmentTable apartmentRows={filteredRows} isLoading={isStudentListLoading} />

      </NormalContainerWithHeader>
    </>

  )
}

export default CoordiApatmentList